import { render, staticRenderFns } from "./Karir.vue?vue&type=template&id=7fed061a&scoped=true&"
import script from "./Karir.vue?vue&type=script&lang=js&"
export * from "./Karir.vue?vue&type=script&lang=js&"
import style0 from "./Karir.vue?vue&type=style&index=0&id=7fed061a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fed061a",
  null
  
)

export default component.exports